<template>
    <router-view />
</template>
<script>
    export default {
        name: 'Register'
    }
</script>